import { useTranslation } from 'react-i18next';

import { useClosedWorkflowEmploymentDetailsReportData } from '~/data/reports';
import { SavedReportSettingsType } from '~/data/reportSettings';

import { useEmploymentDetailsReport } from '../Common/EmploymentDetailsReport/useEmploymentDetailsReport';
import { WorkflowReportBase } from '../Common/WorkflowReportBase';
import { EmploymentDetailsReportConfig } from '../types';

export const ClosedWorkflowEmploymentDetailsReport = () => {
  const { t } = useTranslation();

  const config: EmploymentDetailsReportConfig = {
    reportType: SavedReportSettingsType.ClosedWorkflowEmploymentDetails,
    dataFetchHook: useClosedWorkflowEmploymentDetailsReportData,
    useReportHook: useEmploymentDetailsReport,
    reportTitle: t('laClosedWorkflowsReport'),
    reportSubtitle: t('laOpenWorkflowsReportEmpDetails'),
  };

  return (
    <WorkflowReportBase
      config={config}
      initialColumnVisibilityModel={{
        startDate: false,
        endDate: false,
        info: false,
        jobGrade: false,
        taxNumber: false,
        vacationBalanceCalculation: false,
        calculateHoursBalance: false,
      }}
    />
  );
};
